import { useState } from 'react';
import { appleDeviceImage } from '../lib/appleModels';

// DevicePhoto: ảnh máy chính chủ Apple (giống Apple Business Manager) tra theo ProductName.
// - Không có ProductName hợp lệ HOẶC ảnh tải lỗi -> hiển thị `fallback` (mặc định: ô xám .ph).
// - `className` là lớp khung (vd "ph" ở list, "modal-icon" ở header). Ảnh phủ khung bằng
//   object-fit:cover (xén phần nền trong suốt hai bên, máy hiện đầy chiều cao khung).
export default function DevicePhoto({ product, className = 'ph', fallback = null }) {
  const [failed, setFailed] = useState(false);
  const src = appleDeviceImage(product);
  if (!src || failed) return fallback !== null ? fallback : <div className={className} />;
  return (
    <div className={`${className} ph-img`}>
      <img src={src} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />
    </div>
  );
}
